module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"prediction":"Prediction","panchanga":"Panchanga","calendar":"Calendar","support":"Support","settings":"Settings"}}')
  delete Component.options._Ctor
}
